import { lazy } from 'react';
import { PASSWORD_RESET, PASSWORD_RESET_SUCCESS, SIGN_IN, SIGN_UP } from './paths';

const Homepage = lazy(() => import('../pages/Homepage'));
const KYC = lazy(() => import('../pages/KYC'));
const Contacts = lazy(() => import('../pages/Contacts'));
const Partnership = lazy(() => import('../pages/Partnership'));
const Reviews = lazy(() => import('../pages/Reviews'));
const SiteMap = lazy(() => import('../pages/SiteMap'));
const Rules = lazy(() => import('../pages/Rules'));
const Articles = lazy(() => import('../pages/articles/Articles'));
const ArticleDetails = lazy(() => import('../pages/articles/ArticleDetails'));
const LearningMaterials = lazy(() => import('../pages/articles/LearningMaterials'));
const ExchangeDetails = lazy(() => import('../pages/ExchangeDetails'));
const CityHomepage = lazy(() => import('../pages/CityHomepage'));
const NotFound = lazy(() => import('../pages/NotFound'));
const CryptoCity = lazy(() => import('../pages/CryptoCity'));
const SignInPage = lazy(() => import('../features/auth/SignIn'));
const SignUpPage = lazy(() => import('../features/auth/SignUp'));
const ResetPasswordPage = lazy(() => import('../features/auth/ResetPasswordPage'));
const ResetPasswordSuccessPage = lazy(() =>
  import('../features/auth/ResetPasswordPage').then((module) => ({
    default: module.ResetPasswordSuccessPage,
  })),
);
const Politica = lazy(() => import('../pages/Politica'));
const Invoice = lazy(() => import('../pages/Invoice'));
const Franchise = lazy(() => import('../pages/Franchise'));
const ExchangeRates = lazy(() => import('../pages/ExchangeRates'));
const SkyCapitalPaymentPage = lazy(() => import('../pages/SkyCapitalPaymentPage'));

export const publicRoutes = [
  { path: SIGN_IN, element: <SignInPage /> },
  { path: SIGN_UP, element: <SignUpPage /> },
  { path: PASSWORD_RESET, element: <ResetPasswordPage /> },
  { path: PASSWORD_RESET_SUCCESS, element: <ResetPasswordSuccessPage /> },
];


export const commonRoutes = [
  { path: 'exchange-details/:exchangeId', element: <ExchangeDetails /> },
  { path: 'bitcoin/:cityName/exchange/', element: <CryptoCity /> },
  { path: 'bitcoin/:cityName/', element: <CryptoCity /> },
  { path: 'usdt/:cityName/exchange/', element: <CityHomepage /> },
  { path: 'usdt/:cityName/', element: <CityHomepage /> },
  { path: 'exchange/', element: <Homepage /> },
  { path: '', element: <Homepage /> },
  { path: 'kyc', element: <KYC /> },
  { path: 'articles', element: <Articles /> },
  { path: 'learning-materials', element: <LearningMaterials /> },
  { path: 'article/:slug', element: <ArticleDetails /> },
  { path: 'reviews', element: <Reviews /> },
  { path: 'contacts', element: <Contacts /> },
  { path: 'partnership', element: <Partnership /> },
  { path: 'site-map', element: <SiteMap /> },
  { path: 'rules', element: <Rules /> },
  { path:'politica', element: <Politica />},
  { path:'invoice', element: <Invoice />},
  { path:'franchise', element: <Franchise />},
  { path:'usdt-rates', element: <ExchangeRates />},
  { path: 'auto-payment/:orderUuid', element: <SkyCapitalPaymentPage /> },
  { path: '*', element: <NotFound /> }
];
